import { ClassName } from '@/global/types'
import { WTitle } from '@alice-health/wonderland-react'
import classNames from 'classnames'
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react'

interface ProviderDrawerSectionProps extends PropsWithChildren {
  title: string
  /** Conteudo alinhado a direita do titulo. */
  action?: ReactNode
  className?: ClassName
}

/*
 * Espacamentos do handoff (nodes 26:40868 e 26:41637): 32px acima e abaixo,
 * 16px entre o titulo e o conteudo.
 *
 * A linha entre secoes vem do handoff (nodes I378:31647;26:40624, anotado
 * "Faltando o divider", 26:40627 e 26:40633), que desenha `border-bottom` em
 * toda secao menos a ultima — dai o `last:border-b-0`.
 *
 * A cor e 5% de preto, que e a das duas primeiras secoes do handoff e a mais
 * proxima do `divide-y` interno do `ProviderInfoSection`. A terceira secao
 * esta desenhada em 10%; tratado como ruido do arquivo, nao como regra.
 *
 * De `lg` para cima a caixa da secao ja e a de 476px do handoff, porque o
 * padding horizontal vem do `ProviderDrawer`. No mobile o padding e da
 * propria secao, entao a linha corre de ponta a ponta.
 */
const ProviderDrawerSection: FunctionComponent<ProviderDrawerSectionProps> = ({
  title,
  action,
  children,
  className
}) => {
  return (
    <div
      data-testid='provider-drawer-section'
      className={classNames(
        'flex flex-col py-gl-spacing-08 gap-gl-spacing-04 px-gl-spacing-06 lg:px-0',
        'border-b border-gl-color-transparent-black-05 last:border-b-0',
        className
      )}
    >
      <div className='flex items-center justify-between gap-gl-spacing-04'>
        {/* `heavy` em `xsmall` e o `Label/Medium Heavy` do handoff. */}
        <WTitle
          className='drawer-section-title-type'
          size='xsmall'
          variant='heavy'
        >
          {title}
        </WTitle>

        {action}
      </div>

      {children}
    </div>
  )
}

export { ProviderDrawerSection }
